var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isMoreThanOneScreen),expression:"isMoreThanOneScreen"}],staticClass:"scroll-up",attrs:{"data-component":"ScrollUp"}},[_c('button',{on:{"click":_vm.scrollUp}},[_c('img',{attrs:{"src":require("@/assets/icons/scroll-up.svg"),"alt":"Scroll up"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }